import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => { return import('./views/Home.vue'); },
    },
    {
      path: '/missions',
      name: 'missions',
      component: () => { return import('./views/mission/Missions.vue'); },
    },
    {
      path: '/missions/profile',
      name: 'profile',
      component: () => { return import('./views/ViewEditProfile.vue'); },
    },
    {
      path: '/missions/signup/:missionId',
      name: 'mission-signup',
      component: () => { return import('./views/mission/MissionSignup.vue'); },
    },
    {
      path: '/admin/missions',
      name: 'manage-missions',
      component: () => { return import('./views/mission/ManageMissions.vue'); },
    },
    {
      path: '/admin/mission/:missionId',
      name: 'edit-mission',
      component: () => { return import('./views/mission/EditMission.vue'); },
    },
    {
      path: '/admin/missions/:missionId/missionGoers',
      name: 'mission-goers',
      component: () => { return import('./views/mission/MissionGoers.vue'); },
    },
    {
      path: '/admin/missions/new',
      name: 'new-mission',
      component: () => { return import('./views/mission/CreateMission.vue'); },
    },
    {
      path: '/admin/vaccines',
      name: 'vaccines',
      component: () => { return import('./views/ManageVaccines.vue'); },
    },
  ],
});
